

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/text-helper';
import {getGroupProgress} from 'helpers/game-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import Button from 'components/ui/button/button';
import PopupGroupWarning from 'components/ui/popup-group-warning/popup-group-warning';
import './game-status.scss';

const GameStatus = ({languageId, deviceInfo, gameData, groupsData, goToPage}) => {
	/* Get theme id */
	const themeId = (gameData.themeId ? gameData.themeId : 'theme-1-1');

	/* Hide / show warning popup */
	const [showWarningPopup, setShowWarningPopup] = useState(false);

	/**
	 * Check if all groups have completed the game
	 */
	const handleGoToNextPage = () => {
		let allGroupsCompleted = true;
		groupsData.forEach((g) => {
			if (!allGroupsCompleted) return;

			const groupProgress = getGroupProgress(themeId, g);
			if (groupProgress < 100) allGroupsCompleted = false;
			
		});
		if (allGroupsCompleted) {
			goToNextPage();
		} else {
			setShowWarningPopup(true);
		}
	};

	/**
	 * Go to next page
	 */
	const goToNextPage = () => {
		goToPage('game-results-intro');
	};

	return (
		<div className={'GameStatus ' + deviceInfo.orientation + (groupsData.length !== 0 ? ' hasGroups' : '')}>
			{/* Home btn */}
			<div className="GameStatus-homeBtn" onClick={() => {goToPage('settings');}} />

			{/* Content */}
			<div className="GameStatus-content">
				<GameProgress 
					languageId={languageId}
					progressStepId={'groups'}
					deviceInfo={deviceInfo}
				/>

				<div className='GameStatus-title'>
					<span>{getText('pages_gameStatusTitle', languageId)}</span>
				</div>
				<div className='GameStatus-text'>
					<span>{getText('pages_gameStatusText1', languageId)}</span>
				</div>
				<div className={'GameStatus-groups' + (groupsData.length === 0 ? ' waiting' : '')}>
					{groupsData.map((group) => {
						const groupProgress = getGroupProgress(themeId, group);
						return (
							<div key={group.id} className="GameStatus-group">
								<div className="GameStatus-groupProgressTrack">
									<div className="GameStatus-groupProgressBar" style={{width: groupProgress + '%'}} />
								</div>
								<div className="GameStatus-groupName"><span>{group.name}</span></div>
							</div>
						);
					})}
				</div>
				<div className='GameStatus-text'>
					<span>{getText('pages_gameStatusText2', languageId)}</span>
				</div>
			</div>

			<div className="GameStatus-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-groups');}}
				/>
			</div>
			<div className="GameStatus-nextBtn">
				<Button 
					classes={['orange', 'results', 'fullHeight']}
					text={getText('general_viewAnswers', languageId)}
					onClick={() => {handleGoToNextPage();}}
				/>
			</div>

			{showWarningPopup && 
				<PopupGroupWarning 
					languageId={languageId}
					deviceInfo={deviceInfo}
					goToNextPage={goToNextPage}
					setShowWarningPopup={setShowWarningPopup}
				/>}
		</div>
	);
};

GameStatus.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	groupsData: PropTypes.array.isRequired,
	goToPage: PropTypes.func.isRequired,
};

export default GameStatus;